var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"asc-alert-label--container"},[_c('asc-label',{class:['asc-alert-label', _vm.bold ? 'asc-alert-label--bold' : ''],attrs:{"size":"md","value":_vm.value,"color":_vm.color}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }